var Vue = require("vue");
import VueResource from "vue-resource";
import Router from "vue-router";
var VeeValidate = require("vee-validate");
import { PhoneValidator } from "./util/custom-validator";
import PetOwnerInquiry from '../components/petOwnerInquiry/petOwnerInquiry.vue';
import PageNotFound from '../components/pagenotfound/pagenotfound.vue';
import ModalPopup from "../components/util/modalPopup.vue";

var rootPath = (window as any).BaseUrl;
var applicationName = document.getElementsByTagName("title")[0].innerHTML;

//use
Vue.use(Router);
Vue.use(VeeValidate);
Vue.use(VueResource);

//custom globals on the vue instance
Vue.prototype.$rootPath = rootPath;
Vue.prototype.$rootApiPath = rootPath + "api/";

//Validator extensions
VeeValidate.Validator.extend("phone", PhoneValidator);

const router = new Router({
    base: rootPath,
    routes: [
        {
            path: '/', name: 'PetOwnerInquiry', component: PetOwnerInquiry, meta: { title: 'Pet owner inquiry' }
        },
        {
            path: '*', name: 'PageNotFound', component: PageNotFound, meta: { title: 'Page not found' }
        },
    ],
    linkActiveClass: "active"
});

Vue.http.interceptors.push((request, next) => {
    //Updating $lastServerRequestDate each time a new request is made
    Vue.prototype.$lastServerRequestDate = new Date();

    // continue to next interceptor
    next(response => {
        switch (response.status) {
            case (401):
                window.location.href = '/';
                break;
            case (404):
                window.location.href = '*';
                break;
        }
    });
});

//component registration
Vue.component("v-modalPopup", ModalPopup);

router.beforeEach((to, from, next) => {
    document.title = to.meta.title + " - " + applicationName;
    document.body.className = `page-${to.name}`;
    window.scrollTo(0, 0);
    next();
});

new Vue({
    render: h => h(PetOwnerInquiry),
}).$mount('#petOwnerInquiryApp')

